import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, HardHat, ArrowRight, PhoneCall, Ruler } from "lucide-react";
export default function StructuralDamageAfterStormOrHurricane() {
  return <section data-section-id="247307" id="hero-with-h1-intro" className="relative bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-secondary/5 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col justify-center space-y-8">
            <div className="space-y-4">
              <Badge variant="secondary" className="w-fit bg-secondary/10 text-secondary-foreground border-secondary/20">
                <ShieldCheck className="mr-1 size-3" />
                Certified Insurance Inspections
              </Badge>
              
              <h1 className="font-default text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-foreground">
                4-Point Inspection in South Florida
              </h1>
              
              <p className="font-default text-lg text-muted-foreground max-w-[600px] leading-relaxed">
                Our comprehensive 4-point inspections evaluate your property's roof, electrical, plumbing, and HVAC systems. We provide the detailed reporting commonly required by insurance carriers for policy renewals and new coverage.
              </p>
            </div>

            {}
            <ul className="grid gap-3 sm:grid-cols-2">
              <li className="flex items-center gap-3 text-sm font-medium text-foreground">
                <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <HardHat className="size-4" />
                </div>
                HVAC & Plumbing
              </li>
              <li className="flex items-center gap-3 text-sm font-medium text-foreground">
                <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <Ruler className="size-4" />
                </div>
                Electrical Systems
              </li>
              <li className="flex items-center gap-3 text-sm font-medium text-foreground">
                <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <ShieldCheck className="size-4" />
                </div>
                Roof Integrity
              </li>
            </ul>

            {}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button size="lg" asChild className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
                <Link to="/FourPointInspectionSouthFloridaPage">
                  <PhoneCall className="mr-2 size-4" />
                  Request a 4-Point Inspection
                </Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="w-full sm:w-auto border-border text-foreground hover:bg-accent">
                <Link to="/HomeInspectionServicePage">
                  View All Services
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-[600px] lg:max-w-none">
            <div className="relative aspect-[4/3] lg:aspect-square overflow-hidden rounded-2xl shadow-2xl border border-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/south_florida_inspection_systems.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/south_florida_inspection_systems.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/south_florida_inspection_systems.png-wvc-sizes" alt="Professional inspector checking electrical and HVAC systems in a South Florida home" className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" loading="eager" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 bg-background/95 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-border/50 flex items-center gap-4">
                <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-secondary-foreground">
                  <ShieldCheck className="size-6" />
                </div>
                <div>
                  <p className="font-default font-semibold text-foreground">Detailed Reporting</p>
                  <p className="font-default text-sm text-muted-foreground">Carrier-ready documentation</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}